// i18n area 'backups' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.ru-RU.meta.json.
import type { enUS } from './backups'

export const ruRU: typeof enUS = {
  ckpt: {
    contents: 'Принимает',
    contentsHint:
      'Что сюда может лечь. «Checkpoints» — это конфигурация кластера, «Резервные копии данных» — копии виртуальных машин: два прочтения складываются, одно назначение может принимать оба.',
    content: { checkpoints: 'Checkpoints', backups: 'Резервные копии данных' },
    destinationsTitle: 'Цели резервного копирования',
    checkpointsTitle: 'Контрольные точки',
    restoreTitle: 'Восстановление',
    addDestination: 'Добавить цель',
    addDestinationTitle: 'Добавить цель резервного копирования',
    editDestinationTitle: 'Изменить цель',
    storage: 'Хранилище',
    storageHint:
      'Хранилище файлового типа (dir/NFS/CIFS/CephFS) — артефакты лежат в нем обычными файлами, в пространстве имен платформы.',
    schedule: 'Расписание',
    scheduleNone: 'Только вручную',
    scheduleHourly: 'Каждый час',
    scheduleDaily: 'Ежедневно',
    scheduleWeekly: 'Еженедельно',
    scheduleHour: 'Час',
    scheduleWeekday: 'День',
    scheduleHint:
      'У контрольных точек по расписанию нет оператора, который введет мастер-пароль: секреты из хранилища ключей упаковываются заглушками.',
    retention: 'Глубина хранения',
    retentionHint:
      'Сколько контрольных точек по расписанию хранить — сборщик удаляет самые старые сверх этого числа. Ручные контрольные точки и точки, созданные перед восстановлением, не удаляются никогда.',
    paused: 'На паузе',
    pausedHint:
      'Блэкаут оператора: пока длится пауза, на этой цели ничего не планируется и ничего не прореживается — и политики данных, и контрольные точки. Идущие прогоны никогда не трогаются.',
    orphanRuns: '{n} осиротевших запусков',
    orphanRunsHint:
      'Запланированные запуски policy, которых больше нет на этом назначении: никакая retention ими не управляет — никогда не считаются и не подрезаются — и удаляет их только рука. Линза «backups» в tvirt diagnose называет удалённые policy.',
    rescan: 'Повторно принять артефакты',
    rescanTitle: 'Повторное принятие артефактов {name}',
    rescanHint:
      'Восстанавливает каталог резервных копий (VM/CT/App) из манифестов артефактов на назначении. Существующие строки никогда не затрагиваются; копии неизвестных политик остаются сиротами (никогда не удаляются автоматически). Шаг после bootstrap-восстановления.',
    masterpassDrWarning:
      'Сценарий катастрофы: диски LUKS возвращаются ТОЛЬКО из чекпоинта С мастер-паролем. Плановые чекпоинты упаковывают заглушки — периодически делайте ручной чекпоинт с мастер-паролем.',
    policy: {
      title: 'Политики резервного копирования данных',
      hint: 'Именованные политики: какие объекты (kind, теги, scope), как часто, когда прогон может стартовать и сколько копий хранить. Жест зачисления остаётся за владельцем объекта: теги назначаются на его собственном scope.',
      add: 'Добавить политику',
      column: 'Политики данных',
      name: 'Имя',
      nameHint:
        'Метка policy, уникальная в пределах назначения. Запуски следуют за стабильным id policy: переименование бесплатно; удаление делает её запуски сиротами (больше не считаются и не подрезаются).',
      kindLocked: 'Семейство объектов существующей policy нельзя изменить: создайте новую policy.',
      kindLabel: 'Объекты',
      kind: { vm: 'Виртуальные машины', ct: 'Контейнеры', app: 'Приложения' },
      tags: 'Селектор тегов',
      tagsHint: 'Пары tag=значение через запятую, по AND. Пустые теги и scope не выбирают ничего — никогда «всё».',
      scopes: 'Scope',
      scopesHint: 'Пути scope (поддеревья), через запятую, между собой по OR.',
      windowStart: 'Окно с',
      windowEnd: 'Окно до',
      windowHint:
        'Окно выполнения (HH:MM, местное время; начало позже конца перешагивает полночь). Оно управляет только СТАРТОМ: прогон, вылезший за окно, никогда не убивается.',
      mode: 'Режим',
      modeHint:
        'Инкрементальный едет на семействе серий; порванная серия деградирует до full, о чём сказано в журнале.',
      modeFull: 'Full',
      modeIncremental: 'Инкрементальный',
      requireQuiesce: 'Требовать quiesce (guest agent)',
      paused: 'Политика на паузе',
      retentionNone: 'Хранить всё',
      retentionCount: 'Количество',
      retentionGfs: 'Кольца GFS',
      gfs: { keepLast: 'Последние', daily: 'Дневные', weekly: 'Недельные', monthly: 'Месячные', yearly: 'Годовые' },
      gfsHint:
        'Для каждого кольца хранится самая свежая копия каждого из последних N периодов. Хранимая копия держит живой всю свою цепочку — никогда база с сиротами.',
      lastRun: 'Последний прогон',
      neverRan: 'ни разу не выполнялась'
    },
    lastCheckpoint: 'Последняя контрольная точка',
    neverRun: 'Ни разу не создавалась',
    createNow: 'Создать контрольную точку',
    createNowTitle: 'Создать контрольную точку — {name}',
    masterpass: 'Мастер-пароль',
    masterpassHint:
      'Защищает секретные значения из хранилища ключей (argon2id → AES-256-GCM, для каждого значения отдельно). Он нигде не сохраняется: сохраните его сами — без него восстановление подставит заглушки вместо настоящих секретов.',
    masterpassEmptyHint: 'Оставьте пустым, чтобы вместо секретов упаковать явные заглушки.',
    createStarted: 'Создание контрольной точки выполняется…',
    destinationInUseError: "В '{name}' еще лежат контрольные точки — сначала удалите их.",
    origin: 'Происхождение',
    originManual: 'вручную',
    originSchedule: 'по расписанию',
    originPreRestore: 'перед восстановлением',
    originPreChange: 'перед изменением',
    preChangeRetention: 'Чекпоинты перед изменением',
    preChangeRetentionHint:
      'Пусто = отключено. Первая запись конфигурации после периода затишья фиксирует здесь предыдущее состояние (происхождение «перед изменением»); новейшие хранятся до заданного числа — собственная, обрезаемая глубина хранения.',
    diffTitle: 'Предпросмотр изменений',
    diffFailed: 'Предпросмотр не удался',
    diffRetry: 'Повторить',
    diffCounts: '{changed} изменится · {missing} будет создано · {extra} лишних · {equal} идентичны',
    diffChanged: 'меняется',
    diffMissing: 'будет создан',
    diffExtra: 'будет удалён',
    diffJsonb: 'ссылки в jsonb нельзя проверить до применения',
    diffSecret: 'запечатанные поля, несравнимы',
    diffMore: 'ещё {n}…',
    diffNeeded: 'Запуск становится доступен, когда предпросмотр отражает выбор.',
    phase: 'Состояние',
    phaseRunning: 'выполняется',
    phaseComplete: 'завершено',
    phaseError: 'ошибка',
    secrets: 'Секреты',
    secretsMasterpass: 'мастер-пароль',
    secretsPlaceholders: 'заглушки',
    size: 'Размер',
    created: 'Создано',
    destination: 'Цель',
    download: 'Скачать .tvbk',
    deleteCheckpoint: 'Удалить контрольную точку',
    noCheckpoints: 'Контрольных точек нет — создайте одну из какой-нибудь цели.',

    // Раунд #156 (стандартный диалог): полная поверхность чтения записи
    // о резервной копии — строки деталей для полей, которых нет в таблице.
    families: 'Семейства',
    generation: 'Поколение',
    completedAt: 'Завершено',
    errorDetail: 'Детали ошибки',
    manifest: 'Манифест',
    restoreHint: 'Загрузите артефакт .tvbk: проводник покажет, что внутри, затем выберите, что и как восстановить.',
    uploadFile: 'Загрузить файл .tvbk',
    uploading: 'Загрузка…',
    uploadFailed: 'Не удалось открыть артефакт',
    explorerTitle: 'Содержимое контрольной точки',
    checkpointFrom: 'Контрольная точка кластера {cluster}, создана {when} ({origin}, поколение {generation})',
    otherCluster:
      'Эта контрольная точка создана в ДРУГОМ кластере ({cluster}) — восстановление между кластерами появится в одном из будущих раундов.',
    encrypted: 'зашифровано',
    objectsCount: 'объектов: {n}',
    mode: 'Режим',
    modeMerge: 'Merge — согласование: выбранные записи добавляются или обновляются, ничего не удаляется',
    modeOverwrite:
      'Overwrite — побеждает контрольная точка: полностью выбранное семейство заменяется целиком (текущие строки, которых нет в контрольной точке, исчезают)',
    restoreMasterpassHint:
      'Мастер-пароль, с которым была создана эта контрольная точка. Без него зашифрованные секреты восстановятся явными заглушками.',
    checkMasterpass: 'Проверить',
    masterpassOk: 'Мастер-пароль верный',
    masterpassWrong: 'Мастер-пароль неверный',
    parachuteDestination: 'Страховочная цель',
    parachuteHint:
      'Прежде чем тронуть хоть одну строку, задача создает здесь автоматическую контрольную точку перед восстановлением.',
    summaryTitle: 'Что произойдет',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'семейство целиком',
    summaryObjects: 'выбранных объектов: {n}',
    confirmHint:
      'Введите имя кластера ({name}) для подтверждения — восстановление перезаписывает заявленную конфигурацию.',
    confirmField: 'Имя кластера',
    startRestore: 'Восстановить',
    restoreRunning: 'Восстановление выполняется…',
    restoreDone: 'Восстановление завершено — механизмы согласования сходятся к новой декларации.',
    restoreFailed: 'Восстановление не удалось',
    discard: 'Отбросить',
    selectionEmpty: 'Выберите хотя бы одно семейство или объект.'
  },

  backup: {
    intro: {
      title: 'Резервное копирование данных ВМ и контейнеров',
      subtitle: 'Кирпичики, которыми пользуется внешнее ПО резервного копирования',
      whatItIs:
        'TVirt предоставляет четыре примитива: согласованные (quiesced) снимки, отслеживание изменений по каждому диску, NBD-экспорт только для чтения и экспорт конфигурации. Управляют ими Veeam, Bacula, Acronis и им подобные.',
      whatItIsNot:
        'TVirt — не продукт резервного копирования: он ничего не планирует, не применяет политику хранения и не держит архивов ваших данных. Хранение, каталоги и политики восстановления остаются за ПО, которым вы уже пользуетесь.'
    },
    cbt: {
      title: 'Отслеживание изменений',
      colVm: 'ВМ',
      colDisk: 'Диск',
      colState: 'Состояние',
      colBitmaps: 'Битмапы',
      colObservedAt: 'Наблюдалось',
      colChangeId: 'Change ID',
      colMechanic: 'Механизм',
      stateActive: 'Активно',
      stateInactive: 'Выключено',
      stateInconsistent: 'Несогласовано — следующая копия должна быть полной',
      stateBroken: 'Цепочка разорвана — отключите, затем включите как новую цепочку',
      stateSnapshots: 'Всегда включено — дельта между снимками',
      stateUnavailable: 'Недоступно на этом диске',
      mechanic: {
        'qcow2-bitmap': 'Битмап qcow2',
        'rbd-snapdiff': 'Diff снимков Ceph',
        'lvm-thin-delta': 'Дельта thin pool',
        none: 'Нет'
      },
      empty:
        'Нет дисков ВМ. Отслеживание читается по дискам: включите его на диске qcow2 или делайте снимки на rbd/SAN.',
      chainBroken: 'Цепочка разорвана',
      chainBrokenText:
        'Разорвана событием {reason}: {bitmaps}. Отключите битмап (цепочка потеряна, следующая копия полная), затем включите его как новую цепочку.',
      lineages: 'Эпохи',
      epochFrozen: 'заморожена в снимке {snapshot}',
      epochLost: 'потеряна ({cause})',
      epochRecording: 'записывает на голове',
      milestones: 'Вехи (снимки)',
      enable: 'Включить отслеживание',
      disable: 'Отключить',
      reset: 'Сбросить',
      changedAreas: 'Изменённые области',
      denied: 'У вас нет разрешения на этой ВМ',
      enableTitle: 'Включить отслеживание изменений',
      disableTitle: 'Отключить отслеживание изменений',
      resetTitle: 'Сбросить битмап',
      areasTitle: 'Изменённые области',
      bitmapName: 'Имя битмапа',
      bitmapNameHint: 'Своё имя: tvirt- и tvbk- принадлежат платформе',
      granularity: 'Гранулярность (байты)',
      granularityHint: 'Степень двойки; по умолчанию 65536',
      bitmap: 'Битмап',
      disableHint: 'Удаляет битмап и всю историю его эпох: следующая копия должна быть полной.',
      resetHint: 'Очищает битмап — новая база: change ID старше сброса больше не составляется.',
      areasFrom: 'От снимка',
      areasTo: 'До снимка',
      areasRun: 'Вычислить',
      areasResult: '{count} изменённых областей, {bytes}',
      areasEmpty: 'Между двумя снимками нет изменённых областей',
      areasZero: 'нули',
      areasMore: 'показаны первые {shown} из {count}',
      submit: 'Подтвердить',
      error: 'Действие отслеживания не удалось'
    },
    exports: {
      title: 'Открытые экспорты NBD',
      colVm: 'ВМ',
      colDisk: 'Диск',
      colSnapshot: 'Снимок',
      colBitmap: 'Битмап',
      colPhase: 'Фаза',
      colNode: 'Узел',
      colEndpoint: 'Endpoint',
      colExpires: 'Истекает',
      colCreated: 'Открыт',
      colError: 'Ошибка',
      phase: {
        preparing: 'Подготовка',
        ready: 'Готов',
        closed: 'Закрыт',
        error: 'Сбой'
      },
      expiresIn: 'через {minutes} мин',
      expired: 'истёк',
      empty: 'Экспортов нет. Сессия чтения отдаёт один диск в одном снимке NBD-клиенту; сессия записи заполняет нетронутый диск остановленной ВМ. Обе умирают по истечении срока.',
      endpointHint: 'TLS с CA кластера; имя экспорта — это билет, он умирает вместе с сессией',
      closeDenied: 'У вас нет разрешения закрывать экспорты этой ВМ',
      open: 'Открыть экспорт NBD',
      openTitle: 'Открыть экспорт NBD',
      openDisk: 'Диск',
      openBitmap: 'Битмап (необязательно)',
      openBitmapHint:
        'Публикует эпоху этого битмапа, замороженную в этом снимке, как meta-context изменённых экстентов (только диски qcow2)',
      openTtl: 'Время жизни (минуты)',
      openSubmit: 'Открыть',
      openError: 'Не удалось открыть экспорт',
      colMode: 'Режим',
      mode: {
        read: 'Чтение',
        write: 'Запись'
      },
      caCertificate: 'CA кластера',
      caCopy: 'Копировать PEM',
      caDownload: 'Скачать ca-cert.pem',
      caHint: 'Запишите PEM в ca-cert.pem в приватном каталоге и подключайтесь через nbds://…?tls-certificates=<каталог> (nbdcopy, nbdinfo) или --object tls-creds-x509,dir=<каталог>,endpoint=client (qemu-img)',
      caAbsent: 'Сессия не несёт CA (нет PKI)',
      openWrite: 'Открыть экспорт на запись',
      openWriteTitle: 'Открыть экспорт на запись',
      openWriteIntro: 'Диск должен быть нетронутым: рождён пустым, никогда не записан, без снимка; ВМ остановлена. Восстановление ЗАПОЛНЯЕТ диск, а не чинит его. Пока сессия открыта, ВМ не запускается, не делает снимок, не клонируется, а диск не перемещается.',
      openWriteSubmit: 'Открыть',
      openWriteError: 'Не удалось открыть экспорт на запись',
      openWriteDenied: 'У вас нет vm.restore.data на этой ВМ',
      openWriteStopped: 'Остановите ВМ, чтобы открыть экспорт на запись',
      fromDescription: 'Создать ВМ из описания',
      fromDescriptionTitle: 'Создать ВМ из описания',
      fromDescriptionIntro: 'Описание из export-vm-meta возвращается остановленной ВМ с пустыми дисками описанной геометрии — готовой к экспортам на запись, диск за диском. Байты здесь не проходят: их несёт restore-disk (CLI) или NBD-клиент продукта резервного копирования.',
      fromDescriptionDoc: 'Описание (JSON)',
      fromDescriptionDocHint: 'Вставьте документ export-vm-meta или выберите файл',
      fromDescriptionFile: 'Выбрать файл…',
      fromDescriptionInvalid: 'Текст не является JSON-документом',
      fromDescriptionName: 'Имя новой ВМ',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ваш домашний scope',
      fromDescriptionStorage: 'Хранилище дисков',
      fromDescriptionStorageHint: 'Каждый диск рождается здесь, в формате хранилища по умолчанию',
      fromDescriptionMetadataStorage: 'Хранилище метаданных',
      fromDescriptionSameAsStorage: 'То же, что и для дисков',
      fromDescriptionBridge: 'Мост',
      fromDescriptionBridgeHint: 'Без моста или сети ВМ рождается без сетевых карт',
      fromDescriptionNetwork: 'Логическая сеть (fabric/сеть)',
      fromDescriptionSubmit: 'Создать',
      fromDescriptionError: 'Не удалось создать ВМ',
      fromDescriptionDone: 'ВМ создана: {name}',
      fromDescriptionOpen: 'Открыть ВМ',
      fromDescriptionDenied: 'У вас нет vm.create',
      fromDescriptionStillRunning: 'Создание ещё идёт: продолжаем ждать'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Резервные копии данных ВМ',
      titleOnVm: 'Резервные копии данных',
      empty:
        'Копий нет. Копия переносит диски, varstore UEFI и состояние vTPM в назначение и переживает виртуальную машину.',
      colVm: 'ВМ',
      colCreated: 'Снята',
      colPhase: 'Итог',
      colDestination: 'Назначение',
      colContains: 'Содержимое',
      colSize: 'Размер',
      colOrigin: 'Происхождение',
      colMode: 'Тип',
      retentionChip: 'Хранение',
      retentionHint:
        'Правило хранения назначения может удалить эту копию не спрашивая: она рождена расписанием. Ручные копии не подметаются никогда.',
      policyRemoved: 'Policy удалена: {name}',
      policyRemovedHint:
        'Policy, запланировавшая этот backup, больше не существует: никакая retention им не управляет (никогда не подрезается автоматически) — удалите его вручную, когда он больше не нужен.',
      phase: {
        running: 'Выполняется',
        complete: 'Завершена',
        error: 'Неудача'
      },
      origin: {
        manual: 'Вручную',
        schedule: 'По расписанию'
      },
      mode: {
        full: 'Полная',
        incremental: 'Инкрементная'
      },
      contains: {
        disks: 'Диски',
        varstore: 'Varstore UEFI',
        vtpm: 'Состояние vTPM',
        snapshots: 'Снимки'
      },
      vmState: {
        stopped: 'ВМ выключена',
        running: 'ВМ работает (горячее)'
      },
      artifactClass: { metadata: 'Метаданные', data: 'Данные', secret: 'Секрет' },
      detail: {
        tabOverview: 'Сводка',
        tabArtefact: 'Артефакт',
        id: 'Идентификатор',
        scope: 'Область',
        vmState: 'Состояние ВМ при копировании',
        pointInTime: 'Момент данных',
        completedAt: 'Завершена',
        node: 'Узел, выполнивший копирование',
        error: 'Ошибка',
        path: 'Каталог в хранилище',
        checksum: 'sha256 манифеста',
        secretsExposed: 'Чувствительный материал в открытом виде',
        secretsExposedYes: 'Да — назначение не шифрует',
        secretsExposedNo: 'Нет',
        baseBackup: 'Базовая копия',
        tabManifest: 'Манифест',
        manifestHint:
          'Открытый указатель артефакта: одна строка на файл вместе с его sha256. Каталог проверяется и без TVirt — хватает qemu-img, tar и jq.',
        manifestEmpty: 'Манифест не перечисляет файлов.',
        manifestError: 'Манифест не читается',
        colEntry: 'Файл',
        colClass: 'Класс',
        colSha: 'sha256'
      },
      create: {
        action: 'Скопировать сейчас',
        title: 'Скопировать сейчас',
        submit: 'Запустить копирование',
        destination: 'Назначение',
        destinationHint: 'Только назначения, принимающие копии.',
        noDestinations: 'Ни одно назначение не принимает копии: создайте его в Система → Checkpoints.',
        contentsHint:
          'Едут все диски, varstore UEFI и состояние vTPM. Последние два — самая суть: запечатанный гость должен снова загрузиться.',
        error: 'Копирование не запустилось',
        stillRunning: 'Копирование ещё идёт — оно продолжится, даже если вы закроете окно.',
        vmRunning:
          'Машина {phase}: резервной копии нужна устойчивая ВМ — выключенная для холодного копирования, работающая для горячего.'
      },
      restore: {
        action: 'Восстановить',
        title: 'Восстановить',
        intro: 'Восстановление необратимо. Выберите, куда вернутся данные: в новую машину или поверх исходной.',
        modeNewVm: 'Восстановить в НОВУЮ ВМ',
        modeNewVmHint:
          'Не трогает ничего существующего — этим вариантом копию проверяют. Новый идентификатор и свежевыданные MAC.',
        modeOver: 'Перезаписать исходную ВМ',
        modeOverHint: 'Уничтожает текущие данные целевой ВМ, без возврата. Машина должна быть выключена.',
        newName: 'Имя новой ВМ',
        newNameHint: 'Оно должно быть свободно в целевой области.',
        storage: 'Хранилище для дисков',
        storageHint:
          'Обязательно: манифест записывает размер и формат диска, но никогда — хранилище, на котором он лежал.',
        metadataStorage: 'Хранилище для varstore и vTPM',
        metadataStorageHint: 'Куда лягут идентичность UEFI и состояние vTPM.',
        sameAsStorage: 'То же, что и у дисков',
        bridge: 'Bridge хоста',
        bridgeHint:
          'Каждая записанная сетевая карта вернётся на этот bridge с новым MAC. Оставлено пустым — ВМ родится без карт, и это более безопасное умолчание.',
        overwriteTitle: 'Вы собираетесь перезаписать эту ВМ',
        overwriteName: 'Имя',
        overwriteId: 'Идентификатор',
        overwriteDisks: 'Диски, которые будут перезаписаны',
        overwriteNoDisks: 'Дисков нет.',
        overwriteKeeps:
          'Нетронутыми остаются идентификатор, имя, область, сетевые карты и MAC: копия — это ДАННЫЕ, конфигурация — это checkpoint.',
        confirmField: 'Имя ВМ',
        confirmHint: 'Введите {name} для подтверждения.',
        targetLoading: 'Чтение целевой ВМ…',
        targetRunning:
          'Целевая ВМ {phase}: восстановление перезаписывает байты под гостем, поэтому требует её выключенной.',
        targetGone: 'Исходную ВМ больше не прочитать: остаётся восстановление в новую ВМ.',
        onlyComplete: 'Копия {phase}: восстанавливать может только завершённая копия.',
        submitNewVm: 'Восстановить в новую ВМ',
        submitOver: 'Перезаписать',
        error: 'Восстановление не запустилось',
        stillRunning: 'Восстановление ещё идёт — копирование целых дисков требует времени.'
      }
    },
    guest: {
      title: {
        ct: 'Резервные копии данных контейнеров',
        app: 'Резервные копии данных App'
      },
      tabTitle: 'Резервные копии',
      empty: 'Резервных копий нет. Копия переносит постоянные данные на назначение и переживает свой объект.',
      colSubject: {
        ct: 'Контейнер',
        app: 'App'
      },
      colCreated: 'Создана',
      colPhase: 'Итог',
      colDestination: 'Назначение',
      colContains: 'Содержимое',
      colSize: 'Размер',
      colOrigin: 'Происхождение',
      policyRemoved: 'Policy удалена: {name}',
      policyRemovedHint:
        'Policy, запланировавшая этот backup, больше не существует: никакая retention им не управляет (никогда не подрезается автоматически) — удалите его вручную, когда он больше не нужен.',
      phase: {
        running: 'Выполняется',
        complete: 'Завершена',
        error: 'Не удалась'
      },
      origin: {
        manual: 'Ручная',
        schedule: 'Плановая'
      },
      state: {
        stopped: 'Объект остановлен',
        running: 'Объект работает (заморожен)'
      },
      contains: {
        rootfs: 'Дерево rootfs',
        config: 'Конфигурация',
        volumes: 'Постоянные тома',
        root: 'Постоянный root'
      },
      artifactClass: {
        metadata: 'Метаданные',
        data: 'Данные',
        secret: 'Секрет'
      },
      create: {
        action: 'Сделать копию сейчас',
        title: 'Новая резервная копия',
        submit: 'Запустить копию',
        error: 'Копия не запустилась',
        destination: 'Назначение',
        destinationHint: 'Только назначения, принимающие резервные копии данных.',
        noDestinations:
          'Ни одно назначение не принимает резервные копии данных: добавьте назначению «Резервные копии данных».',
        hint: {
          ct: 'Путешествует всё дерево rootfs, верно (числовые владельцы, xattr, ACL), плюс объявленная конфигурация в манифесте. Работающий контейнер ЗАМОРАЖИВАЕТСЯ на всё время упаковки: crash-consistent копия, объявленная.',
          app: 'Путешествуют ТОЛЬКО постоянные тома (и постоянный root), плюс конфигурация в манифесте. Эфемерное исключено ратификацией, и манифест его называет; env-значения, объявленные секретными, не путешествуют.'
        },
        stillRunning: 'Копия ещё выполняется — упаковка целых деревьев занимает время.'
      },
      detail: {
        tabOverview: 'Обзор',
        tabManifest: 'Манифест',
        id: 'Идентификатор',
        scope: 'Область',
        state: 'Состояние при копировании',
        pointInTime: 'Данные на момент',
        completedAt: 'Завершена',
        node: 'Узел, который копировал',
        error: 'Ошибка',
        path: 'Каталог в хранилище',
        checksum: 'sha256 манифеста',
        manifestHint: 'Индекс артефакта: по записи на файл с его sha256 — без хэшей «копия есть» — акт веры.',
        manifestError: 'Манифест не читается',
        manifestEmpty: 'В манифесте нет артефактов.',
        colEntry: 'Файл',
        colClass: 'Класс',
        colSha: 'sha256',
        excluded: 'Исключено ратификацией (не путешествует)',
        secretKeys: 'Опущенные секретные env-ключи (#307) — введите их заново после восстановления'
      },
      restore: {
        action: 'Восстановить',
        title: 'Восстановление',
        submit: 'Восстановить',
        error: 'Восстановление не запустилось',
        stillRunning: 'Восстановление ещё выполняется — распаковка целых деревьев занимает время.',
        onlyComplete: 'Копия {phase}: восстановить может только завершённая копия.',
        asNew: {
          ct: 'В НОВЫЙ контейнер — ничего не разрушает: жест, которым проверяют копию',
          app: 'В НОВОЕ App — ничего не разрушает: жест, которым проверяют копию'
        },
        over: {
          ct: 'ПОВЕРХ исходного контейнера — заменяется всё дерево rootfs',
          app: 'ПОВЕРХ исходного App — заменяется содержимое каждого постоянного тома'
        },
        name: 'Имя нового объекта',
        storage: 'Хранилище',
        storageHint: 'Куда приземляются восстановленные данные — манифест никогда не записывает потерянный pool.',
        storageDeclared: 'Хранилища, объявленные в манифесте',
        bridge: 'Мост хоста',
        bridgeHint:
          'Каждая записанная карта возвращается на этот мост со свежим MAC. Пусто = рождается неподключённым, самое безопасное умолчание.',
        node: 'Узел',
        nodeHint: 'Член, на котором App возрождается: узел — идентичность кластера и никогда не приходит из манифеста.',
        secretKeysWarning:
          'Env-значения, объявленные секретными, не путешествуют в копии: возрождённая копия хочет их заново введёнными (журнал задачи называет ключи).',
        overInventory: 'Вы собираетесь перезаписать этот объект',
        confirmType: 'Введите {name} для подтверждения',
        targetGone: 'Исходный объект больше не читается: остаётся восстановление как нового.',
        targetLoading: 'Чтение целевого объекта…',
        targetRunning: 'Целевой объект работает: восстановление заменяет байты под гостем и хочет его остановленным.'
      }
    }
  }
}
